<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/users/table">用户管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <span slot="header">封号</span>
      <el-form ref="form"
               :model="form"
               :rules="freezeFormRules"
               size="medium"
               label-width="140px"
               @submit.native.prevent="onSubmit()">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item label="封号状态"
                          prop="freeze_status">
              <el-select v-model="form.freeze_status"
                         placeholder="请选择"
                         class="width-max">
                <el-option v-for="item in options.freeze_status"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="封号原因"
                          prop="freeze_reason">
              <el-select v-model="form.freeze_reason"
                         placeholder="请选择"
                         class="width-max">
                <el-option v-for="item in options.freeze_reason"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="form.freeze_reason === 99" label="封号原因" prop="freeze_reason_desc">
              <el-input placeholder="请输入封号原因" v-model="form.freeze_reason_desc"></el-input>
            </el-form-item>
            <el-form-item label="添加黑名单池">
              <div class="blacklist-checkboxes">
                <el-checkbox v-model="form.add_blacklist_idnum">身份证</el-checkbox>
                <el-checkbox v-model="form.add_blacklist_cellphone">手机号</el-checkbox>
              </div>
            </el-form-item>
            <div class="blacklist-tips">
              <div class="tip-item">*释: 身份证加入黑名单池后,下次用户换号实名该身份证,提示你的身份已冻结</div>
              <div class="tip-item">手机号加入黑名单池,下次用户用此手机号将无法登录,提示该账号已冻结</div>
            </div>
          </div>
        </div>
        <el-form-item>
          <el-button type="primary"
                     native-type="submit">提交表单
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>

  </div>
</template>

<script>
import { freezeFormRules } from '../users.rules.js'

export default {
  components: {},
  data () {
    return {
      freezeFormRules,
      form: {
        userid: this.$route.params.userid,
        freeze_status: null,
        freeze_reason: null,
        freeze_reason_desc: '',
        add_blacklist_idnum: false,
        add_blacklist_cellphone: false,
      },
      options: {
        freeze_status: [
          {label: '阶段封号', value: -1},
          {label: '永久封号', value: -2},
        ],
        freeze_reason: [
          {label: '多账号', value: 1},
          {label: '非本人使用', value: 2},
          {label: '虚假提交', value: 3},
          {label: '账号异常', value: 4},
          {label: '恶意抢单', value: 5},
          {label: '态度恶劣', value: 6},
          {label: '本人申请', value: 7},
          {label: '其他', value: 99},

        ],
      },
      loading: false,
    }
  },
  computed: {},
  watch: {},
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },
  created () {},
  mounted () {},
  methods: {
    onLoad () {
    },
    onReload () {
      this.onLoad()
    },
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          request.common('freezeUser', this.form).then((res) => {
            this.$confirm(this.$route.meta.title + '成功, 是否返回用户列表？', '提示', {type: 'success'}).then(() => {
              this.$router.push({path: '/users/table'})
            }, () => {
              this.$refs.form.resetFields()
            })
          })
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
.blacklist-checkboxes {
  .el-checkbox {
    margin-right: 20px;
  }
}

.blacklist-tips {
  margin-top: 10px;
  margin-left: 50px;
  padding-bottom: 20px;

  .tip-item {
    color: #909399;
    font-size: 12px;
    line-height: 1.8;
    margin-bottom: 4px;
  }
}
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/users/pages/UsersFreezeForm.vue